type ReportIconProps = {
  size?: number;
  color?: string;
  className?: string;
};

export const ReportIcon = ({ size = 24, color = "#231F20", className }: ReportIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <line x1="3.6" y1="1.6" x2="3.6" y2="22.4" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
      <path
        d="M4 2H13.6987C14.0209 2 14.2821 2.26117 14.2821 2.58333V2.58333C14.2821 2.9055 14.5432 3.16667 14.8654 3.16667H20C20.5523 3.16667 21 3.61438 21 4.16667V13C21 13.5523 20.5523 14 20 14H14.8654C14.5432 14 14.2821 13.7388 14.2821 13.4167V13.4167C14.2821 13.0945 14.0209 12.8333 13.6987 12.8333H4"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};
